import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
};

export const meGetReports = createQueryFn(
  QueryNameSpace.meGetReports,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params], number | undefined>) => {
    const [, params] = queryKey;

    const data = await DigiobcanApi.meGetReports({
      ...params,
      ...(pageParam && { offset: pageParam }),
    });

    return data;
  },
);
